var map = {
	"./calendarDate.js": 25,
	"./calendarLimitTo.js": 26,
	"./calendarTruncateEventTitle.js": 27,
	"./calendarTrustAsHtml.js": 28
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35;



/*****************
 ** WEBPACK FOOTER
 ** ./src/filters \.js$
 ** module id = 35
 ** module chunks = 0
 **/